import { ethers } from 'ethers';

import useWrappedRPC from './useWrappedRPC';

function useWithdraw() {
  const { sendTransactionWithGas } = useWrappedRPC();

  const handleWithdraw = async (receivedWalletAddress, ethAmount) => {
    try {
      if (!ethers.utils.isAddress(receivedWalletAddress)) {
        throw new Error('Invalid wallet address');
      }

      const weiValue = ethers.utils.parseEther(ethAmount);
      const hexWeiValue = ethers.utils.hexlify(weiValue);
      const transactionRequest = {
        to: receivedWalletAddress,
        value: hexWeiValue,
      };
      const txUiConfig = {
        header: `Withdraw`,
        description: `Withdraw ${ethAmount} RON to address: ${receivedWalletAddress}`,
        buttonText: `Withdraw`,
      };

      const txReceipt = await sendTransactionWithGas(transactionRequest, txUiConfig);
      if (!txReceipt) throw new Error('Transaction failed on blockchain');

      return {
        success: true,
        message: `Sent ${ethAmount} RON to ${receivedWalletAddress}`,
        data: txReceipt.hash,
      };
    } catch (error) {
      console.error('Withdraw transaction failed:', error);
      return { success: false, message: error.message };
    }
  };

  return { handleWithdraw };
}

export default useWithdraw;
